// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendedPodcasts-cls1_Km0","cls2":"RecommendedPodcasts-cls2_0SL RecommendedPodcasts-cls1_Km0"};